<div class="d-flex flex-wrap pt-3">
  <span *ngFor="let drawback of drawbacks.items" class="col-3 mb-3 text-center">
    {{ drawback }}
  </span>

  <span *ngIf="drawbacks.items.length === 0" class="text-muted">
    Il n'y a actuellement aucun moins pour ce bien.
  </span>
</div>
